import React, { useEffect, useState } from 'react';
import DefaultTable from '../ui/Table/Table';
import { deleteCisDataRow, deleteEventCisDataRow } from '../../helper/helper';
//import ExpandLessIcon from '@mui/icons-material/ExpandLess';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const columns = [
  {
    field: 'saleInvoice',
    headerName: 'Sales Invoice',
    width: 140,
    hideable: false,
    // headerAlign: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'storeId',
    headerName: 'Store ID',
    width: 110,
    hideable: false,
    description: 'Store Channel Code',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'specialistId',
    headerName: 'Sp. ID',
    hideable: false,
    width: 100,
    description: 'Sales Person/Tendered By',
    headerClassName: 'super-app-theme--header',
    //headerAlign: 'left'
  },
  {
    field: 'user',
    headerName: 'User',
    width: 180,
    hideable: false,
    description: 'VFLOW User',
    //headerAlign: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'manuallyUploadedBy',
    headerName: 'Manual',
    width: 130,
    headerClassName: 'super-app-theme--header',
    description: 'CIS Uploaded Manually on VFLOW',
    valueGetter: (params) => (params.row.manuallyUploadedBy ? 'Yes' : 'No'),
  },

  {
    field: 'tenderedDate',
    headerName: 'Date-Tend.',
    description: 'Tendered Date',
    width: 140,
    hideable: false,
    headerClassName: 'super-app-theme--header',
    //headerAlign: 'center'
  },
  {
    field: 'activationDate',
    //headerName: 'Activation Date',
    headerName: 'Date-Act.',
    description: 'Activation Date',
    // headerAlign: 'center',
    width: 140,
    hideable: false,
    headerClassName: 'super-app-theme--header',
  },

  {
    field: 'accountNum',
    headerName: 'Cust. Account',
    description: 'Customer Account Number',
    hideable: false,
    width: 170,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'customerName',
    headerName: 'Cust. Name',
    description: 'Customer Full Name',
    width: 190,
    hideable: false,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'email',
    headerName: 'Cust. Email',
    width: 260,
    description: 'Customer Email Address',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'phoneNum',
    headerName: 'Phone Number',
    description: 'Customer Phone Number',
    hideable: false,
    width: 150,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'tempPhoneNum',
    headerName: 'Temp. Number',
    description: 'Temporary Phone Number',
    width: 150,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'planName',
    headerName: 'Plan Name',
    description: 'Rate Plan Name',
    width: 200,
    headerClassName: 'super-app-theme--header',
    //headerAlign: 'center'
  },
  // FN: auto row height  end
  {
    field: 'planPrice',
    headerName: 'Plan Price',
    description: 'Customer Rate Plan Price',
    headerClassName: 'super-app-theme--header',
  },

  {
    field: 'connectionType',
    headerName: 'Conn. Type',
    description: 'Customer Payment(or Connection) Type',
    width: 130,
    headerClassName: 'super-app-theme--header',
  },

  // { field: 'oneTimeCharges', headerName: 'One Time Charge',width: 140 },
  {
    field: 'oneTimeCharges',
    headerName: 'Conn. Fee',
    description: 'Plan One-time Fees & Charges(Connection Fee)',
    width: 130,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      const value = params.row.oneTimeCharges;
      return value.startsWith('$') ? value : `$${value}`;
    },
    /*
    Product SKU	Product Name
    ACCANS001722	Hardware Upgrade Connection Fee: $45
    ACCANS001519	Postpaid Connection Fee $45
    ACCANS001520	Prepaid Connection Fee: $10
    */
  },

  {
    field: 'simNumber',
    headerName: 'SIM',
    hideable: false,
    width: 180,
    headerClassName: 'super-app-theme--header',
    description: 'SIM Number',
    //type: 'number'
  },
  //{ field: 'imei', headerName: 'IMEI', hideable: false, width: 140 },
  // FN: putting here so it can be fixed and due to auto row height does not look bad
  {
    field: 'imei',
    headerName: 'IMEI',
    hideable: false,
    width: 180,
    description: 'Phone IMEI Number',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'phoneMake',
    headerName: 'Device',
    description: 'Device Model',
    width: 300,
    headerClassName: 'super-app-theme--header',
    //, headerAlign: 'center'
  },

  {
    // FN: need array? might be multiple promotions so easy to show in tables?
    field: 'activatedPromotion',
    headerName: 'Promotions',
    description: 'Activated Promotion(s)',
    hideable: false,
    width: 300,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'phoneProtectionPlan',
    headerName: 'PPP Plan',
    width: 200,
    description: 'Phone Protection Plan',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'addons',
    headerName: 'Add-Ons',
    width: 200,
    headerClassName: 'super-app-theme--header',
    hide: true,
  },
  {
    field: 'deposit',
    headerName: 'Deposit',
    description: 'Customer Billing Deposit',
    width: 105,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'retailPrice',
    headerName: 'Price',
    description: 'Device Retail Price',
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      let value = params.row.retailPrice;
      return value.replace(/\.00$/, '');
    },
  },
  {
    field: 'amountYouPaid',
    headerName: 'Paid',
    description: 'Customer Paid Amount',
    width: 110,
    headerClassName: 'super-app-theme--header',
    hide: true,
    valueGetter: (params) => {
      const value = params.row.amountYouPaid;
      return value.startsWith('$') ? value : `$${value}`;
    },
  },
  {
    field: 'myBalanceOwing',
    headerName: 'Balance Owing',
    description: 'Customer Current My Tab Balance Owing',
    width: 130,
    headerClassName: 'super-app-theme--header',
  },
  // FN: autopay is incorrect
  //{ field: 'autoPayPre', headerName: 'Auto Pay Pre' },
  // { field: 'autoPayPost', headerName: 'Auto Pay Post' },
];

/*
export function SortedDescendingIcon() {
  return <ExpandMoreIcon className="icon" />;
}

export function SortedAscendingIcon() {
  return <ExpandLessIcon className="icon" />;
}
*/
const DashboardTable = ({
  employeeData,
  csvFileName = 'ActivationSheet',
  eventinfoforCis,
  pageSizeOptions = [10, 25, 50, 100],
}) => {
  const [arrIds, setArrIds] = useState([]);
  const [data, setData] = useState(employeeData);

  useEffect(() => {
    setData(employeeData);
  }, [employeeData]);

  async function deleteCisData(id) {
    let saleInvoice = null;
    id.forEach((singleId) => {
      const cis = data.find((cis) => cis._id === singleId);
      if (cis) {
        saleInvoice = saleInvoice ? `${saleInvoice}, ${cis.saleInvoice}` : cis.saleInvoice;
      }
    });
    let response = null;
    if (eventinfoforCis) {
      response = await deleteEventCisDataRow({ id, saleInvoice });
    } else {
      response = await deleteCisDataRow({ id, saleInvoice });
    }

    if (response) {
      setData((prevData) => prevData.filter((cis) => !id.includes(cis._id)));
    }
  }

  const rows = data?.map((row) => ({
    _id: row._id,
    saleInvoice: row.saleInvoice,
    tenderedDate: row.tenderedDate,
    customerName: row.customerName,
    email: row.email,
    accountNum: row.accountNum,
    deposit: row.deposit,
    retailPrice: row.retailPrice,
    phoneProtectionPlan: row.phoneProtectionPlan,
    activatedPromotion: row.activatedPromotion,
    phoneNum: row.phoneNum,
    tempPhoneNum: row.tempPhoneNum,
    simNumber: row.simNumber,
    imei: row.imei,
    amountYouPaid: row.amountYouPaid,
    connectionType: row.connectionType,
    activationDate: row.activationDate,
    phoneMake: row.phoneMake,
    planName: row.planName,
    planPrice: row.planPrice,
    myBalanceOwing: row.myBalanceOwing,
    oneTimeCharges: row.oneTimeCharges,
    addons: row.addons,
    autoPayPre: row.autoPayPre,
    autoPayPost: row.autoPayPost,
    specialistId: row.specialistId,
    storeId: row.storeId,
    user: row.user,
    manuallyUploadedBy: row.manuallyUploadedBy,
  }));
  return (
    <div className="tablecontainer">
      <DefaultTable
        rows={rows ? rows : []}
        columns={columns}
        columnHeaderHeight={50}
        onRowSelectionChange={(ids) => setArrIds(ids)}
        deleteBtnProps={{
          onClick: () => deleteCisData(arrIds),
          disabled: arrIds.length === 0,
          msg: `Are you sure you want to delete the data <b>${arrIds
            .slice(0, 5)
            .map((id) => {
              const cis = employeeData.find((cis) => cis._id === id);
              return cis ? cis.saleInvoice : '';
            })
            .filter((invoice) => invoice)
            .join(', ')}${arrIds.length > 5 ? ', ...' : ''}</b>?`,
        }}
        csvFileName={csvFileName}
        sx={{
          border: 'none',
          whiteSpace: 'normal',
          // border: 0,
          '& .MuiDataGrid-row': {
            borderColor: 'white',
            borderTopStyle: 'solid',
            //borderRadius: 8
            //borderTop: 1,
            //borderBottom:1
          },
          // '& .MuiDataGrid-column': {
          // borderColor: 'black', borderTopStyle: 'solid',
          //borderLeft: 0
          //},

          '& .super-app-theme--header': {
            color: 'var( --secondary-bg-color)',
            fontSize: 15,
            letterSpacing: 0.6,
            // fontStyle:'oblique',
            // textTransform: 'uppercase',
            // mx: 'auto',
            // backgroundColor: 'rgba(255, 7, 0, 0.55)',
            // borderBottom: '5px solid',
            /* TODO: FN- servere side rendering and minimize bundle size
                https://mui.com/material-ui/guides/server-rendering/
                */

            // lineHeight: 1.2,
            //  mb: 0.2
            /*'@media (max-width:600px)': {
                  fontSize: 17,     
             },*/
          },
        }}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: pageSizeOptions[0] },
          },
          columns: {
            columnVisibilityModel: {
              // Hide columns status and traderName, the other columns will remain visible
              addons: false,
              amountYouPaid: false,
              myBalanceOwing:false
            },
          },
        }}
        pageSizeOptions={pageSizeOptions}
        showToolbar
        rowSpacingType="border"
        rowHeight={50}
        disableColumnMenu={true}
        checkboxSelection
        disableRowSelectionOnClick
        tableWrapperProps={{
          className: 'bottomtable',
          style: { height: 650, width: '100%' },
        }}
        // FN: will add wuto hight once data extraction and storage is fixed
        // getRowHeight={() => 'auto'}
        //getEstimatedRowHeight={() => 50}
        //virtualizeColumnsWithAutoRowHeight

        // TODO: FN- need to add search filter: https://mui.com/x/react-data-grid/overlays/
        // virtualizeColumnsWithAutoRowHeight

        /* FN: TO DO:columns should resizable because some
        values are longe
        */
        //  disableColumnResize={false}
      />
    </div>
  );
};

export default DashboardTable;
